import Stack from '@mui/material/Stack'
import React, { useState } from 'react'
import Autocomplete from '../../components/Autocomplete'
import Button from '@mui/material/Button'
import { SearchEntity, WatchListItem, WatchListItemType } from '@finance-lab/utils/types'
import { WatchListsApi } from '../../api/WatchListApi'
import { GROUP_LABELS } from './WatchListGroup'
import { userMessageAtom, userMessageStore } from '../../atoms/userMessageAtom'
import UserEventApi from '../../api/UserEventApi'
import { AddAvisorWatchItem } from './AddAdvisorWatchItem'

const watchListApi = new WatchListsApi()
const userEventApi = new UserEventApi()

export const AddWatchItem = ({ onChange, type }: { onChange: () => Promise<void>; type: WatchListItemType }) => {
    const [isSaving, setIsSaving] = useState(false)
    const [selectedSearchItem, setSelectedSearchItem] = useState<SearchEntity | null>(null)
    const [inputValue, setInputValue] = useState('')
    const typeLowercase = GROUP_LABELS[type].toLocaleLowerCase()

    const handleChange = (item: SearchEntity | null) => {
        setSelectedSearchItem(item)
    }

    const handleAddItem = (item: Pick<WatchListItem, 'id' | 'name'>) => {
        if (item === null) {
            console.warn('item is null')
            return
        }

        void (async () => {
            setIsSaving(true)
            try {
                await watchListApi.createItem(type, item.id)
                userMessageStore.set(userMessageAtom, {
                    type: 'success',
                    message: `${item.name} lades till i bevakningslistan.`,
                })
                setSelectedSearchItem(null)
                setInputValue('')
                await onChange()

                await userEventApi.logEvent(UserEventApi.EVENT_TYPES.ADD_WATCH_LIST_ITEM, { type })
            } catch (err: unknown) {
                if (err instanceof Error && 'status' in err && err.status === 409) {
                    userMessageStore.set(userMessageAtom, {
                        type: 'warning',
                        message: `${item.name} finns redan i bevakningslistan.`,
                    })
                    setSelectedSearchItem(null)
                    setInputValue('')
                }
                console.error(err)
            } finally {
                setIsSaving(false)
            }
        })()
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement> & { defaultMuiPrevented?: boolean }) => {
        if (event.code === 'Enter' && selectedSearchItem) {
            event.preventDefault()
            handleAddItem(selectedSearchItem)
        }
    }

    if (type === 'Advisor') {
        return (
            <AddAvisorWatchItem
                onAdd={(item) => {
                    handleAddItem(item)
                }}
                typeLowercase={typeLowercase}
            />
        )
    }

    return (
        <>
            <p style={{ fontWeight: 'bold' }}>Lägg till {typeLowercase} i bevakningslista</p>
            <Stack direction='row' sx={{ maxWidth: 400 }}>
                <Autocomplete
                    inputValue={inputValue}
                    onInputChange={(e, value) => setInputValue(value)}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    placeholder={`Sök ${typeLowercase}`}
                    searchOnlyFor={type}
                    tabIndex={0}
                    value={selectedSearchItem}
                />

                <Button
                    disabled={!selectedSearchItem || isSaving}
                    disableRipple={false}
                    focusRipple
                    loading={isSaving}
                    onClick={() => handleAddItem(selectedSearchItem)}
                    variant='contained'
                    sx={{ marginLeft: 4, minWidth: 100 }}
                    tabIndex={0}
                    type='button'
                >
                    Bevaka
                </Button>
            </Stack>
        </>
    )
}
